export default __webpack_public_path__ + "8797a1557ebfd9ff2a7bb428142714d2.png";